import { render, staticRenderFns } from "./OctCardList.vue?vue&type=template&id=6cd2944a&scoped=true&"
import script from "./OctCardList.vue?vue&type=script&lang=js&"
export * from "./OctCardList.vue?vue&type=script&lang=js&"
import style0 from "./OctCardList.vue?vue&type=style&index=0&id=6cd2944a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cd2944a",
  null
  
)

export default component.exports